import { DriverDebt } from "@legacy/models/DriverDebt";

import { ModelOperator } from "./ModelOperator";
import { ModelOperatorOptions } from "./ModelOperatorOptions";

interface DriverDebtOperatorOptions extends ModelOperatorOptions<DriverDebt, null, null> {}

export class DriverDebtOperator extends ModelOperator<DriverDebt, DriverDebtOperatorOptions, null, null, null> {}
